import ErrorState from './error-state.vue'
import LoadingState from './loading-state.vue'

export const asyncComponent = (component) => {
  return {
    component,
    // loading: LoadingState,
    error: ErrorState,
    delay: 0,
  }
}
export default asyncComponent
